module.exports = __webpack_public_path__ + "static_wap/img/lipei2.d1a4e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/lipei2.png
// module id = rzwi
// module chunks = 1